import React, { useState } from 'react';
import axios from 'axios';

const RequestPasswordReset = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // TODO: Send a request to the server to initiate password reset for the provided email
    // You can use libraries like Axios or fetch to make the API call
    axios.post('/api/resetPassword', { email })
    .then((response) => {
      // Handle the response from the server
      console.log(response.data); // Assuming the server returns some data
    })
    .catch((error) => {
      // Handle any errors that occur during the request
      console.error('Error:', error);
    });
    // Display a success or error message based on the response
    setMessage('A password reset email has been sent to the provided email address.');
  };

  return (
    <div>
      <h2>Reset Password</h2>
      {message && <div>{message}</div>}
      <form onSubmit={handleSubmit}>
        <div>
          <label>Email:</label>
          <input type="email" value={email} onChange={handleEmailChange} required />
        </div>
        <button type="submit">Reset Password</button>
      </form>
    </div>
  );
};

export default RequestPasswordReset;